export class WebsiteCoreIoCKeys {
    //IoCContainer
    public static IWebsiteCoreIoCContainer: string = 'IWebsiteCoreIoCContainer';

    //Settings
    public static IWebsiteCoreSettings: string = 'IWebsiteCoreSettings';
    public static IWebsiteCoreSensitiveSettings: string = 'IWebsiteCoreSensitiveSettings';
}
